import * as yup from 'yup'

export const createAccountSchema = yup.object({
  username: yup.string().required('Username is required'),
  email: yup.string().email().required('Email is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
    .matches(/[0-9]/, 'Password must contain at a number')
    .matches(/^(?=\S+$).+/, 'Password must has no space'),
  first_name: yup.string().required('First Name is required'),
  last_name: yup.string().required('Last Name is required'),
})
